<template>
    <div id="app">
        <Header/>
        <YearsPopup/>
        <router-view></router-view>
    </div>
</template>

<script>
import "./assets/css/reset.min.css"
import "./assets/js/rem"
import Header from './components/header.vue'
import YearsPopup from './components/yearsPopup.vue'
export default {
    name: "app",
    components: { 
        Header, 
        YearsPopup
    },
    mounted() {
        this.changeSize();
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
        window.addEventListener(resizeEvt, this.changeSize);

        // 获取并设置 title & keywords & description & shareQrcode
        this.$store.dispatch('getConfig');
        // 获取导航
        this.$store.dispatch('getData');
    },
    methods: {
        changeSize(){
            // if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            if (document.documentElement.clientWidth <= 750) {
                this.$store.state.isPhone = true;
            }else{
                this.$store.state.isPhone = false;
            }
            // console.log(this.$store.state.isPhone)
        },
    },
};
</script>

<style lang="scss">
@font-face{
    font-family: 'Avenir';
    src: url("./assets/fonts/Avenir-Book-01.ttf") format("truetype");
    font-style: normal;
    font-weight: normal;
}
@font-face{
    font-family: 'Avenir';
    src: url("./assets/fonts/Avenir-Black-03.ttf") format("truetype");
    font-style: normal;
    font-weight: bold;
}
#app{
    height: 100%;
    // background: #000;
    font-size: .16rem;
    font-family: 'Avenir';

    display: flex;
    flex-direction: column;
    padding-top: .8rem;
    position: relative;
    z-index: 1;
    @media only screen and (max-width: 640px) {
        padding-top: 1.2rem;
    }
    @media only screen and (orientation: landscape) and (max-width: 1023px) {
        padding-top: 0;
    }
}
.container{
    flex: 1;
    position: relative;
}
textarea,
input{
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    outline: none;
    font-family: Arial, Helvetica, sans-serif;
    display: block;
    background: none;
    border: none;
    border-radius: none;
}
iframe{
    width: 100%;
    height: 100%;
}
</style>